import { render, staticRenderFns } from "./publish_date.vue?vue&type=template&id=24536f5c&lang=pug"
import script from "./publish_date.vue?vue&type=script&lang=js"
export * from "./publish_date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports